import React from "react";
import { Link } from "react-router-dom";
import { introText, forSaleListings } from "../../mock";
import PropertyCard from "./PropertyCard";
import SwipeRow from "./SwipeRow";
import { ArrowRight } from "lucide-react";

const Intro = () => {
  return (
    <section id="portfolio" className="bg-[#f3f1ec] py-24 md:py-32">
      <div className="max-w-[1000px] mx-auto px-6 text-center reveal">
        <p className="text-[11px] tracking-luxe uppercase text-[#b4936a] mb-8">Capital Corner Group</p>
        <p data-testid="intro-text" className="font-serif-display text-2xl md:text-[2rem] leading-relaxed text-[#2a2a2a] font-light">
          {introText}
        </p>
      </div>

      <div className="max-w-[1600px] mx-auto px-6 md:px-10 mt-24">
        <div className="flex items-end justify-between mb-12 reveal">
          <div>
            <p className="text-[11px] tracking-luxe uppercase text-[#b4936a] mb-3">Active Portfolio</p>
            <h2 className="font-serif-display text-4xl md:text-5xl font-light text-[#1a1a1a]">
              Listings you could call home!
            </h2>
          </div>
          <Link to="/buy" onClick={() => window.scrollTo({ top: 0 })} data-testid="intro-view-more" className="hidden md:flex items-center gap-2 text-[11px] tracking-luxe uppercase text-[#1a1a1a] hover:text-[#b4936a] transition-colors border-b border-[#1a1a1a] hover:border-[#b4936a] pb-1">
            View More <ArrowRight size={14} />
          </Link>
        </div>

        <div className="reveal">
          <SwipeRow testid="active-portfolio-swipe">
            {forSaleListings.slice(0, 8).map((item) => (
              <PropertyCard key={item.id} item={item} />
            ))}
          </SwipeRow>
        </div>
      </div>
    </section>
  );
};

export default Intro;
